import FlexRow from "../../../../../components/base/FlexRow"
import Icon from "../../../../../components/base/Icon"
import { getOwner } from "../../../../../core/Global"
import { copyToClipboard } from "../../../../../core/Helper"




export default function PercallTokenCard() {

    const owner = getOwner()


    return (
        <div className="card mb-5">
            <div className="card-header border-0">
                <div className="card-title m-0">
                    <h3 className="fw-bolder m-0">Rinvox ID</h3>
                </div>
                <div className="card-action">

                </div>
            </div>
            <div className="card-body border-top p-9">
                <FlexRow className="alert alert-primary" wrap>
                    <input value={owner?.id} type="text" readOnly className="form-control form-control-sm me-2"
                        style={{
                            maxWidth: 400
                        }} />
                    <a href="#"
                        onClick={async e => {
                            e.preventDefault()
                            await copyToClipboard(owner?.id, "Rinvox ID copied to clipboard...")
                        }}>
                        <Icon icon="copy" size={14} />
                    </a>
                </FlexRow>

            </div>
        </div>
    )
}